import * as S from './styled';

function AccountStatBoxIcon ({ children }) {
  return <S.Container>
    {children}
  </S.Container>;
}

export default AccountStatBoxIcon;
